import { useEffect } from "react";

const MINUTES_TO_REFRESH = 5;

export const DashboardRefreshButton = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (!document.querySelector(".offcanvas.show")) {
        window.location.reload();
      }
    }, MINUTES_TO_REFRESH * 60000);
    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 24,
        bottom: 24,
        zIndex: 100,
        width: 64,
        height: 72,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <button
        type="button"
        className="btn btn-text"
        style={{
          borderRadius: "50%",
          width: 64,
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "2rem",
        }}
        aria-label="Refresh Dashboard"
        onClick={handleClick}
      >
        &#x21bb;
      </button>
    </div>
  );
};
